<template>
  <div class="setting-modal">
    <!-- Modal content -->
    <div class="modal-content">
      <h1>Setting</h1>
      <div class="setting-box">
        <h2 class="question" style="padding-bottom:10px;">性別</h2>
        <div style="display: flex;justify-content: center; align-items:center;">
          <input v-model="sex" type="radio" name="sex" id="boy" value="boy" />
          <label for="boy">
            <div class="message you boy">男孩</div>
          </label>
          <input v-model="sex" type="radio" name="sex" id="girl" value="girl" />
          <label for="girl">
            <div class="message you girl">女孩</div>
          </label>
        </div>
      </div>
      <div class="setting-box city-setting">
        <h2 class="question">城市</h2>
        <select name="city" v-model="city">
          <option v-for="city in citys" :key="city.value" :value="city.value">
            {{city.text}}
          </option>
        </select>
      </div>
      <div class="setting-box">
        <button @click="confirm">確定</button>
      </div>
      <p style="opacity:.7;font-size:14px;">將於下次連線生效</p>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'settingModal',
  data() {
    return {
      sex: 'boy',
      city: 'Taipei',
      citys: [
        { text: '基隆', value: 'Keelung' },
        { text: '台北', value: 'Taipei' },
        { text: '新北', value: 'NewTaipei' },
        { text: '桃園', value: 'Taoyuan' },
        { text: '新竹', value: 'Hsinchu' },
        { text: '苗栗', value: 'Miaoli' },
        { text: '台中', value: 'Taichung' },
        { text: '彰化', value: 'Changhua' },
        { text: '南投', value: 'Nantou' },
        { text: '雲林', value: 'Yunlin' },
        { text: '嘉義', value: 'Chiayo' },
        { text: '台南', value: 'Tainan' },
        { text: '高雄', value: 'Kaoshiung' },
        { text: '屏東', value: 'Pingtung' },
        { text: '宜蘭', value: 'Yilan' },
        { text: '花蓮', value: 'Hualian' },
        { text: '台東', value: 'Taitung' },
        { text: '外島', value: 'Island' }
      ]
    };
  },
  methods: {
    ...mapMutations('modal', ['modalClose']),
    ...mapMutations('information',['settingSex','settingCity']),
    confirm() {
      this.$ls.set('information', {
        sex: this.sex,
        city: this.city
      });
      this.settingSex(this.sex);
      this.settingCity(this.city);
      this.modalClose('settingModal');
    }
  },
  mounted() {
    let info = this.$ls.get('information');
    if (info !== null) {
      this.sex = info.sex;
      this.city = info.city;
    }
  }
};
</script>

<style scopped lang="scss">
$temp_color: rgba(218, 125, 104, 0.8);

.setting-modal {
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.6); /* Black w/ opacity */

  h1 {
    opacity: 0.6;
    position: absolute;
    font-weight: bold;
    top: 12px;
    left: 8px;
    border-bottom: 10px solid rgba(244, 133, 133, 0.3);
    padding-bottom: 2px;
    font-size: 18px;
    transform: rotate(-10deg);
  }

  .city-setting {
    select {
      outline: none;
      margin: 10px;
      padding: 10px;
      text-align: center;
      text-align-last: center;
      font-size: 20px;
      opacity: 0.5;
      box-shadow: none;
      background: none;
      //      appearance: none;
      font-weight: bold;
    }
  }
  .setting-box {
    margin-bottom: 10px;
    padding: 10px;
    width: 100%;
    .question {
      font-size: 20px;
      opacity: 0.7;
    }
    button {
      width: 50%;
      line-height: 2em;
      border-radius: 10px;
      background: none;
      font-size: 15px;
      opacity: 0.7;
      border-color: rgba(0, 0, 0, 0.7);
      border: 1px solid;
    }
    button:hover{
      background-color: black;
      color:white;
    }
  }
  .modal-content {
    box-shadow: 5px 5px rgba(50, 50, 50, 0.8);
    position: relative;
    max-width: 350px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    background-color: rgba(252, 255, 253, 0.9);
    margin: auto;
    padding: 20px;
    padding-top: 40px;
    border: 1px solid #888;
    border-radius: 10px;
    text-align: center;
  }

  $me_bg: rgb(170, 250, 140);
  $you_bg: white;
  $boy_bg: rgb(82, 170, 211);
  $girl_bg: rgb(235, 139, 139);
  //specific
  .message {
    user-select: none;
    color: #4b4f56;
    border-radius: 1em;
    padding: 0.8em;
    position: relative;
    word-wrap: break-word;
  }
  .you {
    color: rgb(240, 240, 240);
    background-color: $you_bg;
  }

  .boy {
    background-color: $boy_bg;
  }
  .girl {
    background-color: $girl_bg;
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
